import { useIsManager } from '@axo/shared/data-access/provider';
import { MenuNode } from './menuNode';
import styles from './styles.module.css';

const dummy: MenuNode[] = [
  {
    id: 'C409FC68-5238-45BA-8396-9464D1BABF71',
    label: 'Manager tools',
    icon: 'wrench',
    hasCaret: true,
    className: styles.clickable,
    childNodes: [
      {
        id: '3B06C3B3-6D9E-408F-B185-767C50CCA80E',
        label: 'Redistribute applications',
        disabled: true,
        icon: 'follower',
        className: styles.action,
      },
      {
        id: '1C760FCE-1FF4-4980-95AC-9D4E77A80381',
        label: 'Manage call tags',
        disabled: true,
        icon: 'tag',
        className: styles.action,
      },
    ],
  },
];

export function useManagerToolsNodes() {
  const isManager = useIsManager();
  return isManager ? dummy : [];
}
